import {
  AppBar,
  Box,
  Button,
  Divider,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';
import * as React from 'react';
import StoreFrontOutlined from '@mui/icons-material/StorefrontOutlined';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import { useUserController } from '@maple-tech/auth/userState';
import { userLoggedOut } from '@maple-tech/auth/login';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import PWAPrompt from './PWAInstallation';

export const Header = () => {
  const userState = useUserController();
  // @ts-ignore
  const storeName = userState?.user?.building?.name;
  const theme = useTheme();
  const isMobile = theme.breakpoints.down('md');
  const { t } = useTranslation();
  if (!storeName) return null;
  return (
    <AppBar
      position="static"
      sx={{
        bgcolor: 'background.paper',
        boxShadow: 'none',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar>
        <Stack direction="row" spacing={1} alignItems={'center'} width="100%">
          <Stack
            direction="row"
            spacing={1}
            alignItems={'center'}
            justifyContent={'flex-start'}
            flexGrow={1}
          >
            <img src="/icons/apple-icon-57x57.png" width={32} />
            <Typography variant="h6" color="text.secondary">
              {storeName}
            </Typography>
          </Stack>
          <LanguageSelector mode="list" />
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Button
            // variant="outlined"
            size="small"
            endIcon={<LogoutRounded />}
            onClick={async () => {
              try {
                await userLoggedOut();
                userState?.logout();
                localStorage.clear();
                window.location.reload();
              } catch (e) {
                console.error(e);
              }
            }}
          >
            {/* Logout */}
            {t('Footer.logoutButton')}
          </Button>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
export const Footer = () => {
  const userState = useUserController();
  // const storeName = userState?.user?.building?.name;
  const theme = useTheme();
  const isMobile = theme.breakpoints.down('md');
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        position: isMobile ? 'inherit' : 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'background.paper',
        p: 2,
        mt: isMobile ? 6 : 0,
        textAlign: 'center',
      }}
    >
      {/* <Store */}
      {/* {!!storeName && (
        <Stack
          direction="row"
          spacing={1}
          alignItems={'center'}
          justifyContent={'center'}
          mb={3}
        >
          <StoreFrontOutlined />{' '}
          <Typography variant="body2" color="text.secondary">
            {storeName}
          </Typography>
          <Button
            sx={{ ml: 4 }}
            variant="outlined"
            size="small"
            endIcon={<LogoutRounded />}
            onClick={async () => {
              try {
                await userLoggedOut();
                userState?.logout();
                localStorage.clear();
                window.location.reload();
              } catch (e) {
                console.error(e);
              }
            }}
          >
            {t('Footer.logoutButton')}
          </Button>
        </Stack>
      )} */}
      <Stack
        direction="row"
        spacing={1}
        alignItems={'center'}
        justifyContent={'center'}
      >
        {/* <LanguageSelector /> */}
        <img src="/icons/apple-icon-57x57.png" width={32} />
        <Typography variant="body2" ml={1} color="text.secondary">
          {t('Footer.copyright', { year: new Date().getFullYear() })}

          {/* Maple Tech © 2020 - {new Date().getFullYear()} */}
        </Typography>
      </Stack>
      <PWAPrompt />
    </Box>
  );
};
